module.exports = __webpack_public_path__ + "static/img/30012 (4).22fbab7.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/30000/30012 (4).webp
// module id = XNnP
// module chunks = 14